var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"chartBox",staticClass:"chart-box",staticStyle:{"width":"100%","height":"336px","box-sizing":"border-box","zoom":"1 / zoom"}})
}
var staticRenderFns = []

export { render, staticRenderFns }